import { isAxiosError } from "axios";
import logo from "/ems-logo-only-01.png";
// import "/ems-logo-only-01.png";
import { useRouteError } from "react-router-dom";
import { Button } from "@mui/material";

export default function GenericErrorDisplay() {
  const err = useRouteError();

  function logout() {
    localStorage.clear();
    window.location.reload();
  }

  if (isAxiosError(err)) {
    if (err.status === 401) {
      logout();
    }
  }
  return (
    <div
      style={{
        display: "flex",
        width: "100vw",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img src={logo} height={"300em"} />
      <h1>An Unknown Error Occured</h1>
      <Button
        variant="outlined"
        onClick={() => {
          logout();
        }}
      >
        Clear cache and reload
      </Button>
    </div>
  );
}
